// pages/Home.js
import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import CountdownTimer from '../components/CountdownTimer';
import AboutSection from '../components/AboutSection';
import VideoSection from '../components/VideoSection';
import ScheduleSection from '../components/ScheduleSection';
import Separator from '../components/Separator';
import Carousel from '../components/Carousel';
import ContactENG from '../components/ContactENG';


import CountdownTimerAMZ from '../components/CountdownTimerAMZ';
import AboutSectionAMZ from '../components/AboutSectionAMZ';
import VideoSectionAMZ from '../components/VideoSectionAMZ';


import HeroSectionENG from '../components/HeroSectionENG';
import AboutSectionENG from '../components/AboutSectionENG';
import CountdownTimerENG from '../components/CountdownTimerENG';
import VideoSectionENG from '../components/VideoSectionENG';

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="home-page">
      <HeroSectionENG />

      <Carousel />
      <AboutSectionENG />
      <Separator />
      <VideoSectionENG />
      <ContactENG />
      <Carousel />

    </div>
  );
}

export default Home;
